import { render } from "./SelectDetail.vue?vue&type=template&id=1e1eea95"
import script from "./SelectDetail.vue?vue&type=script&lang=js"
export * from "./SelectDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__